<template>
  <!--发布帖子-->
  <tk-container
    :status="status"
    native-scroll
    style="background: #fff;"
  >
    <!--页面标题-->
    <tkui-header center slot="header">
      <div slot="left-menu" @click="$back()">
        <tkui-button class="icon">
          <tk-icon size="16">return</tk-icon>
        </tkui-button>
      </div>
      发帖
      <!--发布按钮-->
      <action-button
        slot="right"
        class="m-x-12"
        :btn-text="'发布'" :bg-color="'#D84342'"
        :bd-color="'#D84342'" :text-color="'#fff'"
        :min-width="54" :height="35" is-raised is-rounded
        @click.native="postsStory"
        :disabled="clickDisabled"
      ></action-button>
    </tkui-header>
    <div style="background: #fff;">
      <!--帖子内容-->
      <div class="p-x-12 p-t-12">
        <textarea name="hehe" id="text-input" cols="30" rows="8" v-model="content" class="text-input" placeholder="传递正能量 分享新资讯"></textarea>
      </div>
      <!--帖子图片-->
      <three-image-post class="m-t-10" @postImage="receiveParams"></three-image-post>
    </div>
  </tk-container>
</template>

<script>
import threeImagePost from '@/components/threeImagePost'
export default {
  components: {
    threeImagePost
  },
  data () {
    return {
      status: 'loading', // 页面状态
      clickDisabled: false, // 发布帖子按钮状态
      content: '', // 帖子内容
      pictureCombination: [], // 帖子图片
      authorizePostType: null // 授权发帖类别数据
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  methods: {
    /**
    * 初始化数据
    * @date: 2020/3/26
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getAuthorizedPostType() // 获取授权发帖分类
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 获取授权发帖分类
     * @date: 2020/3/26
     */
    async getAuthorizedPostType () {
      let postType = await this.$tkParse.getList('/classes/authorizeAccount', {
        params: {
          limit: 1,
          order: '-createdAt',
          include: 'type',
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (postType.length) { this.authorizePostType = postType[0].type } else { this.authorizePostType = null }
    },
    /**
     * @Description: 接收图片数组
     * @author xiaozan
     * @date 2020/5/3
     */
    receiveParams (arr) {
      this.pictureCombination = arr
    },
    /**
    * 发布帖子
    * @date: 2020/3/26
    */
    async postsStory () {
      if (!this.content) { return this.$tkGlobal.toast.add('帖子内容不存在') }
      this.clickDisabled = true
      let obj = {
        content: this.content,
        author: this.userInfo.objectId,
        type: this.authorizePostType ? this.authorizePostType.objectId : null,
        pictureCombination: this.pictureCombination,
        userFans: [],
        reviewsPostsList: []
      }
      let res = await this.$tkParse.post('/classes/InformationPosts', obj).catch(e => {
        this.clickDisabled = false
        this.$tkGlobal.toast.add('网络错误')
        throw e
      })
      this.$tkGlobal.toast.add('发帖成功')
      this.$setFlash('newPostsId', res.data.objectId)
      this.$back()
    }
  }
}
</script>

<style scoped lang="scss">
  /*帖子文本样式*/
  .text-input {
    height: 100%;
    width: 100%;
    min-width: 0;
    overflow-y: auto;
    resize: none;
  }
  .text-input::placeholder {
    font-size: 14px;
    color: rgba(157, 157, 157, 1);
  }
  /*默认分类样式*/
  .default-type {
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    padding: 25px 0;
    margin: 0 15px;
    .default-type-name {
      width: 100px;
      height: 25px;
      text-align: center;
      background-color: rgba(245, 245, 245, 1);
      border-radius: 13px;
      line-height: 25px;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
    }
  }
</style>
